module.exports = __webpack_public_path__ + "static/media/menu_eva_3.b664871a.jpg";